<script setup>
import {useStore} from 'vuex'
import {computed, watch, onUnmounted} from "vue";
import {ProjectApi} from "@/api/projects";

const store = useStore()

const project = computed(() => store.getters.currentProject)
const percentProgress = computed(() => Math.floor((project.status?.all - project.status?.not_collect) / project.status?.all * 100))


let pollingInterval = null

const startPolling = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval)
  }

  pollingInterval = setInterval(() => {
    if (project.value && project.value.id) {
      ProjectApi.object(project.value.id).then(response => {
        project.value = response
        store.commit("set_project", response)
      }).catch(error => {
        console.error('Polling error:', error)
      })
    }
  }, 10000)
}

const stopPolling = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval)
    pollingInterval = null
  }
}

watch(() => project.value?.status?.status, (newStatus, oldStatus) => {
  if (newStatus === 'process') {
    console.log('Starting polling, status changed to process')
    startPolling()
  } else if (oldStatus === 'process' && newStatus !== 'process') {
    console.log('Stopping polling, status changed from process to', newStatus)
    stopPolling()
  }
}, { immediate: true })

watch(project, (newProject) => {
  if (newProject?.status?.status === 'process') {
    startPolling()
  } else {
    stopPolling()
  }
}, { immediate: true })

onUnmounted(() => {
  stopPolling()
})


</script>

<template>
  <div class="" v-if="project && project.status">
    <div class="status-bar">
      <div v-if="project.status?.status === 'process'">
        <span><span class="date">Идёт процесс сбора, старт</span>  {{
          project.last_parser ? $moment(project.last_parser).format("DD.MM.YY HH:mm") : '-'
        }}</span>
        <div class="progress" v-if="percentProgress&&percentProgress!==100">

          <div class="progress-bar" :class="{ 'animate': project.status?.status === 'process' }"
               :style="{width: percentProgress +'%'}">
            <span class="percent">{{ percentProgress }}%</span>
          </div>
        </div>
      </div>
      <div v-else>
      <span> Последняя проверка: <span class="date"> {{
          project.last_parser ? $moment(project.last_parser).format("DD.MM.YY HH:mm") : '-'
        }}</span></span>
        <span>Следующий запуск: <span class="date">{{
            $moment(project.status.next_date).format("DD.MM.YY HH:mm")
          }}</span></span>
        <span>Всего ссылок: <span
            class="date">{{ project.status.all }}</span> глубина сбора, дней: <span class="date">{{
            project.status.days
          }}</span></span>
      </div>


    </div>
  </div>


</template>


<style scoped lang="scss">
.progress {
  .progress-bar {
    background: linear-gradient(
      90deg,
      #4caf50 0%,
      #8bc34a 25%,
      #4caf50 50%,
      #8bc34a 75%,
      #4caf50 100%
    );
    background-size: 200% 100%;
    position: relative;
    overflow: hidden;
    transition: width 0.3s ease;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.4),
        transparent
      );
      transform: translateX(-100%);
    }

    &.animate {
      animation: shimmer 2s linear infinite;

      &::before {
        animation: shine 1.5s ease-in-out infinite;
      }
    }
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.status-bar {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  font-weight: bold;
  gap: 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 3px 10px;

  span {
    display: flex;
    gap: 5px;

    &.date {
      font-weight: normal;
    }
  }
  .progress{
    width: 230px;
    .percent{
      display: inline-block;
      text-align: center;
    }
  }
}

</style>

